import React, { useState } from "react";
import { Link } from "react-router-dom";
import { SignolUtils } from "@src/utils";
import { useManagerContext } from "@src/context/managerContext";
import { BackButton, Modal } from "@src/components/atoms";
import ChangePasswordForm from "@src/components/forms/ChangePasswordForm";
import ProfileCard from "./ProfileCard";

export const ProfilePage = () => {
  const { profile } = useManagerContext();
  const [showChangePassword, setShowChangePassword] = useState(false);

  const useSSO = SignolUtils.getLoginSSO(profile.appUser.username);
  /** TODO 🚧: Change/Reset Password whilst logged in */
  const shouldShowResetPasswordLink = !useSSO;

  return (
    <div className="py-4">
      <div className="relative flex flex-col items-center justify-center mb-8 h-14">
        <div className="absolute self-start ml-4">
          <BackButton />
        </div>
        <h2 className="font-extrabold text-4xl ms-6 md:ms-0">
          Company Profile
        </h2>
      </div>
      <div className="max-w-xl mx-auto p-3">
        <ProfileCard />
        {shouldShowResetPasswordLink && (
          <div className="mt-4">
            Change your password{" "}
            <span
              onClick={() => {
                console.log("clicking for password change");
                setShowChangePassword(true);
              }}
              className="font-bold text-primary-500 underline cursor-pointer"
            >
              here
            </span>
          </div>
        )}
        {/* Modal for password change */}
        {!!showChangePassword && (
          <div>
            <Modal
              open={!!showChangePassword}
              handleClose={() => setShowChangePassword(false)}
            >
              <ChangePasswordForm setOpen={setShowChangePassword} />
            </Modal>
          </div>
        )}
      </div>
    </div>
  );
};
